<template>
  <div class="row">
    <div class="col-md-12">
      <h2 class="mb-0 text-gray-800">Acolhimentos da unidade</h2>
      <h4 class="mb-3 text-gray-800">{{ $route.query.unidade_nome }}</h4>
    </div>
    <div class="col-md-12" v-if="loadUnidade == false">
      <Header :item="item" />
    </div>
    <load v-if="loading" />
    <div v-else class="col-md-12">
      <div class="card mb-0 shadow">
        <div class="card-body">
          <div class="tab-content">
            <div v-if="!cadastrar" class="animate__animated animate__fadeIn">
              <div class="row">
                <div class="col-12">
                  <div
                    class="d-flex align-items-center justify-content-between mb-4"
                  >
                    <div>
                      <button class="btn btn-primary" @click="cadastrar = true">
                        <i class="fas fa-plus-square" />
                        {{ $t("Cadastrar") }}
                      </button>
                    </div>
                    <div>
                      <div class="input-group mb-3">
                        <b-button
                          variant="outline-dark"
                          @click="exportar()"
                          :title="$t('Exportar')"
                          v-b-tooltip.hover
                        >
                          <i class="fas fa-file-excel py-2"></i>
                        </b-button>

                        <select
                          class="form-control"
                          style="max-width: 220px"
                          v-model="status_id"
                          @change="onFilterStatus"
                        >
                          <option value="">Todos os status</option>
                          <option
                            v-for="status in statusList"
                            :key="status.id"
                            :value="status.id"
                          >
                            {{ status.descricao }}
                          </option>
                        </select>

                        <b-input
                          :placeholder="$t('Type to search')"
                          class="form-control search-input"
                          type="text"
                          v-model="search"
                          v-on:change="getItens"
                          aria-describedby="input-search"
                        />
                        <div class="input-group-append" role="button" @click="onSearch">
                          <span class="input-group-text" id="input-search"
                            ><i class="fas fa-search search-icon"
                          /></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <b-table
                    :fields="[
                      {
                        key: 'protocolo',
                        label: $t('Detalhes'),
                      },
                      {
                        key: 'cadastrado',
                        label: $t('Data'),
                      },
                      {
                        key: 'status',
                        label: $t('Status'),
                      },
                      {
                        key: 'actions',
                        label: '',
                        class: 'text-right',
                        thStyle: {
                          width: '95px',
                          minWidth: '95px',
                        },
                      },
                    ]"
                    :items="itemList"
                    :responsive="true"
                    striped
                    hover
                    show-empty
                    small
                    outlined
                    stacked="xs"
                    table-class="mb-3"
                  >
                    <template v-slot:cell(protocolo)="data">
                      Usuário:
                      <b>
                        {{ data.item.nome_acolhido }}
                        {{
                          data.item.usuario_idade
                            ? `,${data.item.usuario_idade} Ano(s)`
                            : ""
                        }}
                      </b>
                      <br />
                      Protocolo:
                      <b>{{ data.item.protocolo }}</b>
                      <br />
                      Técnico:
                      <b>{{ data.item.user?.name || 'Não informado' }}</b> -
                      <span>
                        {{ data.item.tecnico?.profissao || "Não informado" }}
                      </span>
                      <br />
                      Unidade:
                      <b v-if="data.item.unidade">
                        {{ data.item.unidade?.nome }}
                      </b>
                      <br />
                      <i
                        class="mdi mdi-lock mdi-18px text-danger"
                        v-if="data.item.privado == 1"
                        v-b-popover.hover.top="'Acolhimento com sigilo'"
                      ></i>
                    </template>
                    <template v-slot:cell(cadastrado)="data">
                      {{ data.item.cadastrado }}
                    </template>
                    <template v-slot:cell(status)="data">
                      <span v-html="data.item.status_nome"></span>
                    </template>
                    <template v-slot:cell()="data">
                      <b-button
                        :title="$t('Editar')"
                        @click="abrirAcolhimento(data.item, 'editar')"
                        class="px-2 mb-0"
                        size="xs"
                        type="button"
                        v-b-tooltip.hover
                        variant="success"
                        v-if="podeEditarAcolhimento(data.item)"
                      >
                        <i class="mdi mdi-square-edit-outline" />
                      </b-button> 

                      <b-button
                        :title="$t('Visualizar e Imprimir')"
                        @click="abrirAcolhimento(data.item, 'VisualizarEImprimir')"
                        class="px-2 mb-0"
                        size="xs"
                        type="button"
                        v-b-tooltip.hover
                        variant="primary"
                        v-else-if="
                          $store.state.user.role_details.name ==
                            'Coordenador' ||
                          $store.state.user.role_details.name == 'Gestor(a)' ||
                          $store.state.user.role_details.name ==
                            'Técnico(a) de Nível Superior'
                        "
                      >
                        <i class="mdi mdi-eye" />
                      </b-button>
                    </template>
                    <template v-slot:empty="scope">
                      <div class="text-center my-5">
                        <img
                          :alt="$t('No results')"
                          class="mb-5"
                          src="/img/icons/robot.svg"
                          style="max-height: 165px"
                        />
                        <h3 class="bold">
                          {{ $t("No records found") }}
                        </h3>
                      </div>
                    </template>
                  </b-table>

                  <div
                    class="row align-items-center"
                    v-if="itemList.length > 0"
                  >
                    <div class="col-lg-6 col-md-12">
                      <div class="form-group d-inline-flex mb-0">
                        <select
                          class="form-control"
                          style="width: 70px"
                          v-model="perPage"
                          v-on:change="getItens"
                        >
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                        </select>
                      </div>
                      <div class="d-inline-flex ml-2">
                        <b-pagination
                          :per-page="perPage"
                          :total-rows="pagination.total"
                          @change="changePage"
                          v-model="page"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                      <div class="float-lg-right">
                        {{ $t("Showing page") }}
                        {{ pagination.currentPage }}
                        {{ $t("of") }}
                        {{ pagination.totalPages }}
                        {{ $t("pages in") }}
                        {{ pagination.total }}
                        {{ $t("records") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Cadastrar
              v-else
              :familia="familia"
              :publico_alvo="$route.query.tipo_rota"
              @voltar="cadastrar = false"
              @reload="getItens"
            />
          </div>
        </div>
      </div>
    </div>
    <ModalGerenciarVagasCriancas :item="item" @reload="getItens" />
  </div>
</template>
<script>
import Cadastrar from "../AddAcolhimento";
import Header from "../includes/Header";
import ModalGerenciarVagasCriancas from "./includes/ModalGerenciarVagasCriancas";
export default {
  components: { Cadastrar, Header, ModalGerenciarVagasCriancas },
  name: "Acolhimentos",
  metaInfo() {
    return {
      title: this.$i18n.t("Acolhimentos"),
    };
  },
  data() {
    return {
      familia: {},
      cadastrar: false,
      itemList: [],
      page: 1,
      search: "",
      status_id: "",
      statusList: [],
      perPage: 10,
      loadingItens: true,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      user_id: null,
      referencias_recebidas: 1,
      item: { unidade: "", unidade_acolhimento: "" },
      loadUnidade: true,
      isCoordenador: false,
      unidadeUsuario: null,
    };
  },
  mounted() {
    this.carregarPermissoesUsuario();
    this.getItens();
    this.getUnidade();
    this.getStatusAcolhimento();
  },
  methods: {
    carregarPermissoesUsuario() {
      if (this.$store.state.user) {
        const roleUser = this.$store.state.user.role_details?.name;

        this.isCoordenador = roleUser === "Coordenador";

        this.unidadeUsuario = Number(
          this.$store.state.user?.tecnico?.unidade_id ||
          this.$store.state.user?.unidade_id ||
          this.$store.state.unidade
        );
      }
    },
    podeEditarAcolhimento(item) {
      const usuarioId = Number(this.user_id || this.$store.state.user?.id);

      const ehResponsavel =
        item?.user_id && Number(item.user_id) === usuarioId;

      const ehTecnicoVinculado =
        this.isUserInArray(item?.tecnicos ?? [], usuarioId);

      const unidadeAcolhimento = Number(
        item?.unidade_id ||
        item?.unidade?.id ||
        this.$route.params.id
      );

      const ehCoordenadorDaMesmaUnidade =
        this.isCoordenador &&
        this.unidadeUsuario &&
        unidadeAcolhimento &&
        Number(this.unidadeUsuario) === Number(unidadeAcolhimento);

      return ehResponsavel || ehTecnicoVinculado || ehCoordenadorDaMesmaUnidade;
    },
    isUserInArray(tecnicos, user_id) {
      if (!Array.isArray(tecnicos)) return false;
      return tecnicos.some((tecnico) => tecnico && tecnico.user_id === user_id);
    },
    openGerenciarVagasCrianca() {
      this.showModalVagas = true;
      this.$bvModal.show("gerenciar-vagas-criancas");
    },
    getUnidade() {
      this.loadUnidade = true;
      axios
        .get(`api/dashboard/unidade/acolhimento/${this.$route.params.id}`)
        .then((response) => {
          this.item.unidade = response.data.unidade;
          this.item.unidade_acolhimento = response.data;
        })
        .finally(() => {
          this.loadUnidade = false;
        });
    },
    getStatusAcolhimento() {
      axios
        .get("api/dashboard/acolhimentos/status")
        .then((response) => {
          this.statusList = response.data || [];
        });
    },
    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/acolhimentos/geral", {
          params: {
            unidade_id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            status_id: this.status_id,
            export: "ok",
          },
        })
        .then((response) => {
          this.isLoadingMsg = false;
          this.loading = false;

          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          (this.isLoadingMsg = false), (this.loading = false);
        });
    },
    getItens() {
      this.loading = true;
      axios
        .get("api/dashboard/acolhimentos/geral", {
          params: {
            unidade_id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            status_id: this.status_id,
          },
        })
        .then((response) => {
          this.user_id = this.$store.state.user.id;

          
          this.itemList = response.data.data || response.data;

          this.pagination = response.data.pagination || {
            currentPage: 1,
            perPage: this.itemList.length,
            total: this.itemList.length,
            totalPages: 1,
          };

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getItens();
      }
    },
    onSearch() {
      this.page = 1; // volta pra primeira página
      this.getItens();
    },
    onFilterStatus() {
      this.page = 1;
      this.getItens();
    },
    abrirAcolhimento(item,tipo_tela){
      
      let url;

      if(tipo_tela == "editar"){

        if (item.tipo_acolhimento == "crianca"){

          url = `/dashboard/acolhimento/edit/${item.id}`;

        }else{

          url = `/dashboard/acolhimento/${item.tipo_acolhimento}/edit/${item.id}`;

        }

      }else if(tipo_tela == "VisualizarEImprimir"){

        if (item.tipo_acolhimento == "crianca"){

          url = `/dashboard/acolhimento/show/${item.id}`;

        }else{

          url = `/dashboard/acolhimento/${item.tipo_acolhimento}/show/${item.id}`;

        }

      }

      this.$router.push(url);

    },
  },
};
</script>
